import React from "react";
import { observer } from "mobx-react";

// Provenance for research answers. Links open in a new tab with noopener,
// since they point at arbitrary third-party pages the research surfaced.
const CitationsBlock = observer(({ block }) => {
  const citations = block.citations || [];
  if (!citations.length) return null;

  return (
    <div className="copilotCitations">
      <div className="copilotCitations__title">
        {`Source${citations.length === 1 ? "" : "s"}`}
      </div>
      <ol className="copilotCitations__list">
        {citations.map((citation, index) => (
          <li className="copilotCitations__item" key={citation.url}>
            <span className="copilotCitations__index">{index + 1}</span>
            <a
              className="copilotCitations__link"
              href={citation.url}
              target="_blank"
              rel="noopener noreferrer"
              title={citation.url}
            >
              <span className="copilotCitations__label">{citation.title}</span>
              <span className="copilotCitations__domain">{citation.domain}</span>
            </a>
          </li>
        ))}
      </ol>
    </div>
  );
});

export default CitationsBlock;
